export interface ICaseReview {
  id?: number;
  title?: string | null;
  aiChatId?: number | null;
  userId?: number | null;
  isDeleted?: boolean | null;
  step?: string | null;
}

export const defaultValue: Readonly<ICaseReview> = {
  isDeleted: false,
  aiChatId: null,
};
